/**
 * @fileoverview GET handler for the "/engagement/jumpstart_email_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import type { EngagementEmailTemplatesIdResult } from "../engagementEmailTemplatesId";
import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementJumpstartEmailTemplatesId } from "./constants";
import type { GetEngagementJumpstartEmailTemplatesErrors } from "./types";

export const getEngagementJumpstartEmailTemplates = reactQueryFetcherAdapter(
  engagementJumpstartEmailTemplatesId,
  createGetFetcherFunctionWithShadowError<GetEngagementJumpstartEmailTemplatesErrors>()(
    (signal: AbortSignal, id: string): Promise<EngagementEmailTemplatesIdResult> => {
      return fetch(
        `/engagement/jumpstart_email_templates/${id}`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  )
);
